module.exports = __webpack_public_path__ + "static/media/dotnet.22329049.png";